export default "__VITE_ASSET__Bz5paqcX__";